import { START_TOUR } from './actions';

let defaultState = {
	tourSteps: [],
	tourChangeSteps: (_) => {},
	tourCompleted: () => {}
};

export default function tour(state = defaultState, action) {
	switch(action.type) {
		case START_TOUR:
			return {
				...state,
				tourSteps: action.data.tourSteps,
				tourChangeSteps: action.data.tourChangeSteps,
				tourCompleted: action.data.tourCompleted
			};
		default:
			return state;
	}
}
